import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	strokeWidth: "0px",
	width: 24,
	height: 24,
	viewBox: "0 0 72 72",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M36 4C18.374 4 4 18.374 4 36c0 17.626 14.374 32 32 32 17.626 0 32-14.374 32-32C68 18.374 53.626 4 36 4zm0 60.853C20.052 64.853 7.148 51.948 7.148 36 7.148 20.052 20.052 7.148 36 7.148c15.947 0 28.853 12.904 28.853 28.852 0 15.947-12.905 28.853-28.853 28.853z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M36 49.115a2.597 2.597 0 0 0-2.623 2.623A2.597 2.597 0 0 0 36 54.36a2.597 2.597 0 0 0 2.623-2.623A2.597 2.597 0 0 0 36 49.115zM28.027 18.374l-1.469.63 1.26 2.832 1.468-.63c5.456-2.412 11.856-1.783 13.744 1.26 1.994 3.252.735 7.134-3.252 10.596-4.512 3.777-5.351 6.715-5.351 10.282v1.574h3.147v-1.574c0-2.518.315-4.511 4.302-7.869 5.246-4.406 6.715-10.072 3.882-14.583-3.148-5.141-11.541-5.35-17.731-2.518z",
		fill: "currentColor"
	})]
});
export default SvgQuestionMark;
